import { CategoryReviewEditorApi } from "./category-review-editor-api";
import { CategoryReviewEditorForm } from "./category-review-editor-form";
import { CategoryReviewEditorHandler } from "./category-review-editor-handler";
import { CategoryReviewEditorListener } from "./category-review-editor-listener";

function createHandlersByOverlayMap(): WeakMap<HTMLElement, CategoryReviewEditorHandler> {
    return new WeakMap();
}

const handlersByOverlay = createHandlersByOverlayMap();

export class CategoryReviewEditorSetup {
    public static init(rootEl: Document | HTMLElement = document): CategoryReviewEditorHandler | null {
        const setupForm = new CategoryReviewEditorForm(rootEl, rootEl instanceof HTMLElement ? rootEl : document.body);
        const overlayEl = setupForm.getOverlay(rootEl);
        const modalEl = setupForm.getModal(rootEl);

        if (!(overlayEl instanceof HTMLElement) || !(modalEl instanceof HTMLElement)) {
            return null;
        }

        const existing = handlersByOverlay.get(overlayEl);
        if (existing) return existing;

        const form = new CategoryReviewEditorForm(rootEl, modalEl);
        const {
            tabParentEl,
            tabChildEl,
            tabReviewEl,
            panelParentEl,
            panelChildEl,
            panelReviewEl,
            saveBtnEl,
            addBtnEl,
            statusEl,
            addEntryModalEl,
            addEntryCodeEl,
            addEntryNameEl,
            addEntrySubmitBtnEl,
            addEntryCloseBtnEls,
            questionOptionModalEl,
            questionOptionRowsEl,
            questionOptionAddRowBtnEl,
            questionOptionSubmitBtnEl,
            questionOptionCloseBtnEls,
            reviewSettingsModalEl,
            reviewSettingsTitleEl,
            reviewSettingsPanelEl,
            reviewSettingsSaveBtnEl,
            reviewSettingsAddBtnEl,
            reviewSettingsCloseBtnEls,
            closeBtnEls,
            openBtnEls,
        } = form.getElements();

        if (
            !(tabParentEl instanceof HTMLElement) ||
            !(tabChildEl instanceof HTMLElement) ||
            !(panelParentEl instanceof HTMLElement) ||
            !(panelChildEl instanceof HTMLElement) ||
            !(saveBtnEl instanceof HTMLElement) ||
            !(addBtnEl instanceof HTMLElement) ||
            !(addEntryModalEl instanceof HTMLElement) ||
            !(addEntryCodeEl instanceof HTMLInputElement) ||
            !(addEntryNameEl instanceof HTMLInputElement) ||
            !(addEntrySubmitBtnEl instanceof HTMLElement) ||
            !Array.isArray(addEntryCloseBtnEls) ||
            addEntryCloseBtnEls.length === 0 ||
            !(questionOptionModalEl instanceof HTMLElement) ||
            !(questionOptionRowsEl instanceof HTMLElement) ||
            !(questionOptionAddRowBtnEl instanceof HTMLElement) ||
            !(questionOptionSubmitBtnEl instanceof HTMLElement) ||
            !Array.isArray(questionOptionCloseBtnEls) ||
            questionOptionCloseBtnEls.length === 0 ||
            !(reviewSettingsModalEl instanceof HTMLElement) ||
            !(reviewSettingsTitleEl instanceof HTMLElement) ||
            !(reviewSettingsPanelEl instanceof HTMLElement) ||
            !(reviewSettingsSaveBtnEl instanceof HTMLElement) ||
            !(reviewSettingsAddBtnEl instanceof HTMLElement) ||
            !Array.isArray(reviewSettingsCloseBtnEls) ||
            reviewSettingsCloseBtnEls.length === 0
        ) {
            return null;
        }

        const handler = new CategoryReviewEditorHandler({
            api: new CategoryReviewEditorApi(),
            overlayEl,
            modalEl,
            tabParentEl,
            tabChildEl,
            tabReviewEl,
            panelParentEl,
            panelChildEl,
            panelReviewEl,
            saveBtnEl,
            addBtnEl,
            statusEl,
            addEntryModalEl,
            addEntryCodeEl,
            addEntryNameEl,
            addEntrySubmitBtnEl,
            addEntryCloseBtnEls,
            questionOptionModalEl,
            questionOptionRowsEl,
            questionOptionAddRowBtnEl,
            questionOptionSubmitBtnEl,
            questionOptionCloseBtnEls,
            reviewSettingsModalEl,
            reviewSettingsTitleEl,
            reviewSettingsPanelEl,
            reviewSettingsSaveBtnEl,
            reviewSettingsAddBtnEl,
            reviewSettingsCloseBtnEls,
        });

        const listener = new CategoryReviewEditorListener(handler, {
            overlayEl,
            tabParentEl,
            tabChildEl,
            tabReviewEl,
            panelParentEl,
            panelChildEl,
            panelReviewEl,
            saveBtnEl,
            addBtnEl,
            addEntryModalEl,
            addEntrySubmitBtnEl,
            addEntryCloseBtnEls,
            questionOptionModalEl,
            questionOptionSubmitBtnEl,
            questionOptionCloseBtnEls,
            reviewSettingsModalEl,
            reviewSettingsPanelEl,
            reviewSettingsSaveBtnEl,
            reviewSettingsAddBtnEl,
            reviewSettingsCloseBtnEls,
            closeBtnEls,
            openBtnEls,
        });
        listener.register();

        handlersByOverlay.set(overlayEl, handler);
        return handler;
    }
}
